var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPricingIcon = function SvgPricingIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15 14a3 3 0 0 1-3 3v2h-1v-2a3 3 0 0 1-3-3h1a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2c0-1.134-.581-1.505-2.621-2.015C8.919 11.37 8 10.783 8 9a3 3 0 0 1 3-3V4h1v2a3 3 0 0 1 3 3h-1a2 2 0 0 0-2-2h-1a2 2 0 0 0-2 2c0 1.134.581 1.505 2.621 2.015C14.081 11.63 15 12.217 15 14Z"
  })));
};
export default SvgPricingIcon;